import App from './App'
import React from 'react'
import ReactDOM from 'react-dom'
import { StylesProvider } from '@material-ui/core/styles'
import './public/sass/index.scss'
import '@marketing-milk/frontend/dist/frontend.css'
import { createV4Jss } from './theme/v4Jss'
import { captureEntryRoute } from './app/util'

// Runs after the stylesheet imports above deliberately — see createV4Jss.
const jss = createV4Jss()

// Before the first render: the router discards a deep link within it.
captureEntryRoute()

ReactDOM.render(
  <React.StrictMode>
    <StylesProvider jss={jss}>
      <App />
    </StylesProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
